module.exports = __webpack_public_path__ + "static/og-844679a58f612cd34adb0c5f9378970f.png";